import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmailAddressSchema = withDefaults({
  type: 'email-address',
  objectExtensions: ['email-address'],
  fields: [
    {
      kind: 'attribute',
      name: 'email',
    },
    {
      kind: 'attribute',
      name: 'contactType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default EmailAddressSchema;
